import React from 'react';

import { formatSyncedDay } from '../Assets/utils';

import AccountOpportunityName from './AccountOpportunityName';
import RelatedTile from './RelatedTile';

interface Props {
  hasOffer?: boolean;
  opportunity: App.OpportunityPage;
}

export default function AccountOpportunityTile({ hasOffer, opportunity }: Props) {
  const fields = [
    { label: 'Stage', value: opportunity.opportunity_info?.stagename },
    { label: 'Close Date', value: formatSyncedDay(opportunity.sales_and_forecast?.closedate) },
    { label: 'Owner Full Name', value: opportunity.opportunity_info?.opp_owner_lookup_name__c },
  ];

  return (
    <RelatedTile fields={fields} heading={<AccountOpportunityName hasOffer={hasOffer} opportunity={opportunity} />} />
  );
}
